import axiosInstance from "../../../../Utils/axios";
import axios from "axios";
import { paginationQueryParams } from "../../../../Utils/paginationParam";
let cancelToken;

const voucherURL = `api/v1/account-app/vouchermain`;

//obtaining the paginated data
export const getVoucher = ({ rowsPerPage, search, sortOrder, pageNo }) => {
  if (cancelToken) {
    cancelToken.cancel("Operation canceled due to new request.");
  }
  cancelToken = axios.CancelToken.source();
  return axiosInstance.get(`${voucherURL}/list?${paginationQueryParams(rowsPerPage, search, sortOrder, pageNo)}`, {
    cancelToken: cancelToken.token,
  });
};

//obtaining all fiscal sessions
export const getAllVoucher = () => axiosInstance.get(`${voucherURL}/list?ordering=-id`);

//obtaining the previous page data from paginated data
export const getPrevious = (previous) => axiosInstance.get(previous);

//obtaining the next page data from paginated data
export const getNext = (next) => axiosInstance.get(next);

//obtaining the particular page data from paginated data
export const getPageVoucher = ({ number, rowsPerPage, search }) =>
  axiosInstance.get(`${voucherURL}/list?${paginationQueryParams(rowsPerPage, search, "", number)}`);

// get by id
export const getVoucherById = (id) => axiosInstance.get(`${voucherURL}/retrieve/${id}`);

//creating function
export const createVoucher = (body) => axiosInstance.post(`${voucherURL}/create`, body);
//creating function
export const createCostCenterDetails = (body) =>
  axiosInstance.post(`api/v1/cost-center/cost-center-details/create`, body);
//updating function
export const updateVoucher = (id, body) => axiosInstance.patch(`${voucherURL}/update/${id}`, body);
// approve function
export const approveVoucher = (id, body) => axiosInstance.patch(`${voucherURL}/approve/${id}`, body);
//searching function
export const handleSearch = ({ rowsPerPage, search, sortOrder }) => {
  if (cancelToken) {
    cancelToken.cancel("Operation canceled due to new request.");
  }
  cancelToken = axios.CancelToken.source();
  return axiosInstance.get(`${voucherURL}/list?offset=0&limit=${rowsPerPage}&ordering=${sortOrder}&search=${search}`, {
    cancelToken: cancelToken.token,
  });
};
